/*
 * バリデーション（お問い合わせ関連）
 */
import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequiredText, strMax } from '@/utils/validate/conditions';
/**
 * validation: お問い合わせ
 */
export const validateContactMain = {
    company: composeValidators(isRequiredText('企業名を入力してください'), strMax(50, '企業名は50文字以内で入力してください')),
    content: composeValidators(isRequiredText('お問い合わせ内容を入力してください'), strMax(2000, 'お問い合わせ内容は2000文字以内で入力してください')),
    type: composeValidators(isRequiredText('お問い合わせ項目を選択してください')),
};
